export default __webpack_public_path__ + "static/media/984.8eaea1e6.gif";